import { Radio, Table, TableColumnsType } from 'antd';
import Search from 'antd/lib/input/Search';
import Pagination from '../../../../../../../components/Pagination';
import { useTranslation } from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { RootState } from '../../../../../../../store/rootReducer';
import { IEmployeeItem } from '../../../../../../../models/employees.model';
import config from '../../../../../../../lib/config';
import { setCounselorMemberCode } from '../../../../../../../store/entranceCounselor.slice';
import Button from '../../../../../../Button';

interface IProps {
  employees: IEmployeeItem[];
  groupNo?: string;
  keyword?: string;
  page?: number;
  param?: any;
  onSearch?: (memberCode: string | null, page: number | null) => void;
  memberCode?: string;
  onChangeSelect?: (value: boolean) => void;
}

const CounselorContents: FC<IProps> = ({
  employees,
  // groupNo,
  //   keyword,
  //   page,
  param,
  //   onSearch,
  // memberCode,
  onChangeSelect,
}) => {
  const { t, i18n } = useTranslation();

  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState('');
  const [pageNum, setPageNum] = useState(1);
  const [data, setData] = useState<IEmployeeItem[]>([]);
  const [selectedMemberCode, setSelectedMemberCode] = useState(null);
  const [emplName, setEmplName] = useState('');

  useEffect(() => {
    let _data: IEmployeeItem[] = _.cloneDeep(employees);

    if (currentCampus) {
      _data = _data.filter((item) => item.campusCode === currentCampus);
    }

    setData(_data);
  }, [employees, currentCampus]);

  const onSearchHandler = () => {
    let _data: IEmployeeItem[] = _.cloneDeep(employees);
    if (keyword) {
      _data = _data.filter(
        (item) =>
          item.memberName.includes(keyword) || item.webId.includes(keyword),
      );
    }
    setData(_data);
  };
  const handleRadioChange = (e: any, memberCode: any) => {
    if (e.target.checked) {
      setSelectedMemberCode(memberCode);
      dispatch(setCounselorMemberCode(memberCode));
      onChangeSelect && onChangeSelect(true);
    } else {
      onChangeSelect && onChangeSelect(false);
    }
  };

  const columns: TableColumnsType<IEmployeeItem> = [
    {
      title: t('campus.staff.column40'),
      dataIndex: 'memberName',
      key: 'memberName',
      render: (value, record) =>
        i18n.language === 'ko'
          ? value + `(${record?.webId})`
          : record.memberEngName + `(${record?.webId})`,
      align: 'center',
      width: '80%',
    },
    {
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
      width: '0%',
      render: (_, record) => <span hidden={true}>{record.memberCode}</span>,
    },
    {
      title: '선택여부',
      key: 'action',
      align: 'center',
      width: '20%',
      render: (_, record) => (
        <Radio
          checked={selectedMemberCode === record.memberCode}
          onChange={(e) => handleRadioChange(e, record.memberCode)}
        />
      ),
    },
  ];
  return (
    <>
      <div className="comm-bx__between">
        <div className="comm-sch_result">
          {t('common.text.count')}:<b>{data.length}</b>
        </div>
        <div className="comm-btn__area ml-2">
          <div className="w-210p">
            <input
              type="text"
              className="form-control input-text"
              placeholder={t('student.student.placeholder4')}
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') onSearchHandler();
              }}
            />
          </div>
          <Button
            className="btn-basic small black"
            onClick={onSearchHandler}
            text={t('common.button.search')}
          />
        </div>
      </div>
      <div className="comm-table__area mt-0">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: pageNum,
            pageSize: config.miniPageSize,
          }}
        />
      </div>
      <div className="comm-bx__space">
        <div className="common-paging center">
          <Pagination
            count={data?.length}
            page={pageNum}
            setPage={setPageNum}
            mini={true}
            small
          />
        </div>
      </div>
    </>
  );
};
export default CounselorContents;
